import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, withModifiers as _withModifiers, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/product-thumb-sm.png'


const _hoisted_1 = {
  key: 0,
  class: "product__left"
}
const _hoisted_2 = ["alt"]
const _hoisted_3 = {
  key: 0,
  class: "product__title"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "product__description"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "View more...", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "icon-chevron-right" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = { class: "product__list" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "product__list" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["href", "innerHTML"]
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 5,
  class: "product__location"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", { class: "text-color-um-blue" }, "Location")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "map" }, null, -1)
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = { class: "product__right" }
const _hoisted_33 = { class: "product__overview" }
const _hoisted_34 = ["alt"]
const _hoisted_35 = {
  key: 0,
  class: "product__gallery"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("strong", null, "Photo gallery...", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "icon-chevron-right" }, null, -1)
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = ["src", "alt"]
const _hoisted_40 = ["src", "alt"]
const _hoisted_41 = {
  key: 0,
  class: "product__title"
}
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = {
  key: 0,
  class: "product__description"
}
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("strong", null, "View more...", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "icon-chevron-right" }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_48 = { class: "product__list" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("strong", { class: "text-color-um-blue" }, "Research Entity", -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { key: 1 }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_54 = { class: "product__list" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("strong", { class: "text-color-um-blue" }, "Contacts - Responsible person", -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = { key: 1 }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_60 = { class: "product__list" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("strong", { class: "text-color-um-blue" }, "Organization", -1)
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = { key: 1 }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_66 = { class: "product__list" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = ["innerHTML"]
const _hoisted_69 = { key: 1 }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_71 = { class: "product__list" }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = ["innerHTML"]
const _hoisted_74 = { key: 1 }
const _hoisted_75 = ["href", "innerHTML"]
const _hoisted_76 = ["innerHTML"]
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { key: 0 }
const _hoisted_79 = ["innerHTML"]
const _hoisted_80 = { key: 0 }
const _hoisted_81 = ["innerHTML"]
const _hoisted_82 = { key: 1 }
const _hoisted_83 = {
  key: 10,
  class: "product__location"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", { class: "text-color-um-blue" }, "Location")
], -1)
const _hoisted_85 = {
  key: 0,
  class: "product__actions"
}
const _hoisted_86 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_IconTextBlock = _resolveComponent("IconTextBlock")!
  const _component_GoogleMapsSmall = _resolveComponent("GoogleMapsSmall")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Galleria = _resolveComponent("Galleria")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product", !_ctx.compact ? 'product--lg' : ''])
  }, [
    (!_ctx.compact)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("template", null, [
            _createElementVNode("div", {
              class: "product__image",
              style: _normalizeStyle([_ctx.image ? 'background-image:url(' + _ctx.image + ')' : ''])
            }, [
              _createVNode(_component_router_link, { to: _ctx.productURL }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: _ctx.data.title
                  }, null, 8, _hoisted_2)
                ]),
                _: 1
              }, 8, ["to"])
            ], 4)
          ]),
          (_ctx.displayLeftContains('title'))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.data.title)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_router_link, { to: _ctx.productURL }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", {
                            innerHTML: _ctx.data.title
                          }, null, 8, _hoisted_4)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.data.description)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.data.description)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("p", {
                        innerHTML: _ctx.data.description
                      }, null, 8, _hoisted_6),
                      _createVNode(_component_router_link, {
                        class: "router-link read-more text-color-gray-700",
                        to: _ctx.productURL
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7,
                          _hoisted_8
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _hoisted_9
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.displayLeftContains('infoList') && _ctx.data.infoList)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.data.infoList, (list, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _createElementVNode("div", _hoisted_10, [
                    (list.title)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                          _createElementVNode("strong", {
                            class: "text-color-um-blue",
                            innerHTML: list.title
                          }, null, 8, _hoisted_12)
                        ]))
                      : _createCommentVNode("", true),
                    (list.children)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.children, (child, index_child) => {
                            return (_openBlock(), _createElementBlock("p", { key: index_child }, [
                              _createVNode(_component_IconTextBlock, {
                                icon: child.icon,
                                label: child.label,
                                to: child.to,
                                href: child.href
                              }, null, 8, ["icon", "label", "to", "href"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_14
                ], 64))
              }), 128))
            : _createCommentVNode("", true),
          (_ctx.displayLeftContains('accordion') && _ctx.data.accordion)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.data.accordion, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "product__accordion"
                }, [
                  (item.title)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                        _createElementVNode("strong", {
                          class: "text-color-um-blue",
                          innerHTML: item.title
                        }, null, 8, _hoisted_16)
                      ]))
                    : _createCommentVNode("", true),
                  (item.children)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(_component_Accordion, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, index_child) => {
                              return (_openBlock(), _createBlock(_component_AccordionTab, {
                                key: index_child,
                                header: child.title
                              }, {
                                default: _withCtx(() => [
                                  (child.content)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                                    : (child.infoList)
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(child.infoList, (list, index) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                            (list.title)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                                                  _createElementVNode("strong", {
                                                    innerHTML: list.title
                                                  }, null, 8, _hoisted_19)
                                                ]))
                                              : _createCommentVNode("", true),
                                            (list.children)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.children, (child, index_child) => {
                                                    return (_openBlock(), _createElementBlock("p", { key: index_child }, [
                                                      _createVNode(_component_IconTextBlock, {
                                                        icon: child.icon,
                                                        label: child.label,
                                                        to: child.to,
                                                        href: child.href
                                                      }, null, 8, ["icon", "label", "to", "href"])
                                                    ]))
                                                  }), 128))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        }), 128))
                                      : (child.location)
                                        ? (_openBlock(), _createBlock(_component_GoogleMapsSmall, {
                                            key: 2,
                                            location: _ctx.data.location
                                          }, null, 8, ["location"]))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["header"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            : _createCommentVNode("", true),
          (_ctx.displayLeftContains('linkList') && _ctx.data.linkList)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(_ctx.data.linkList, (list, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _createElementVNode("div", _hoisted_21, [
                    (list.title)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                          _createElementVNode("strong", {
                            class: "text-color-um-blue",
                            innerHTML: list.title
                          }, null, 8, _hoisted_23)
                        ]))
                      : _createCommentVNode("", true),
                    (list.children)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.children, (child, index_child) => {
                            return (_openBlock(), _createElementBlock("p", { key: index_child }, [
                              (child.href)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: _ctx.href,
                                    class: "link",
                                    target: "_blank",
                                    innerHTML: child.title
                                  }, null, 8, _hoisted_25))
                                : (child.to)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 1,
                                      class: "link",
                                      to: child.to
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", {
                                          innerHTML: child.title
                                        }, null, 8, _hoisted_26)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (!_ctx.data.accordion.length)
                    ? (_openBlock(), _createElementBlock("hr", _hoisted_27))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            : _createCommentVNode("", true),
          (_ctx.displayLeftContains('location') && _ctx.data.location)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_31))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        (_ctx.data)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "product__image",
              style: _normalizeStyle([_ctx.image ? 'background-image:url(' + _ctx.image + ')' : ''])
            }, [
              _createVNode(_component_router_link, { to: _ctx.productURL }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: _ctx.data.title
                  }, null, 8, _hoisted_34)
                ]),
                _: 1
              }, 8, ["to"])
            ], 4))
          : _createCommentVNode("", true),
        (_ctx.displayContains('gallery'))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.data.gallery)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "read-more text-color-blue",
                      style: {"font-size":"20px"},
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showGallery = true), ["prevent"]))
                    }, _hoisted_38),
                    _createVNode(_component_Galleria, {
                      visible: _ctx.showGallery,
                      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showGallery) = $event)),
                      value: _ctx.data.gallery,
                      "num-visible": 6,
                      "container-style": "max-width: 50%",
                      circular: true,
                      "full-screen": true,
                      "show-item-navigators": true
                    }, {
                      item: _withCtx((slotProps) => [
                        _createElementVNode("img", {
                          src: slotProps.item.itemImageSrc,
                          alt: slotProps.item.alt,
                          style: {"width":"100%","display":"block"}
                        }, null, 8, _hoisted_39)
                      ]),
                      thumbnail: _withCtx((slotProps) => [
                        _createElementVNode("img", {
                          src: slotProps.item.thumbnailImageSrc,
                          alt: slotProps.item.alt,
                          style: {"display":"block"}
                        }, null, 8, _hoisted_40)
                      ]),
                      _: 1
                    }, 8, ["visible", "value"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.displayContains('title'))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (_ctx.data.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createVNode(_component_router_link, { to: _ctx.productURL }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", {
                          innerHTML: _ctx.data.title
                        }, null, 8, _hoisted_42)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.displayContains('description'))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              (_ctx.data.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("p", {
                      innerHTML: _ctx.data.description
                    }, null, 8, _hoisted_44),
                    _createVNode(_component_router_link, {
                      class: "router-link read-more text-color-gray-700",
                      to: _ctx.productURL
                    }, {
                      default: _withCtx(() => [
                        _hoisted_45,
                        _hoisted_46
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _hoisted_47,
        (_ctx.data.researchEntity)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createElementVNode("div", _hoisted_48, [
                (_ctx.data.researchEntity.id)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_49, _hoisted_51))
                  : _createCommentVNode("", true),
                (_ctx.data.researchEntity)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                      _createElementVNode("p", null, [
                        _createVNode(_component_IconTextBlock, {
                          icon: "icon-pin",
                          label: "Research Entity Location",
                          href: _ctx.data.researchEntity.id
                        }, null, 8, ["href"])
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(_component_IconTextBlock, {
                          icon: "pi pi-link",
                          label: "https://www.um.si",
                          href: _ctx.data.researchEntity.id
                        }, null, 8, ["href"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_53
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.data.researchOrganizationContact)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              _createElementVNode("div", _hoisted_54, [
                (_ctx.data.researchOrganizationContact.id)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_55, _hoisted_57))
                  : _createCommentVNode("", true),
                (_ctx.data.researchOrganizationContact)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                      _createElementVNode("p", null, [
                        _createVNode(_component_IconTextBlock, {
                          icon: "icon-user",
                          label: "Firstname Lastname"
                        })
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(_component_IconTextBlock, {
                          icon: "icon-phone",
                          label: "02 23 55 280"
                        })
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(_component_IconTextBlock, {
                          icon: "icon-envelope-3",
                          label: "joe.doe@um.si"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_59
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.data.researchOrganization)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
              _createElementVNode("div", _hoisted_60, [
                (_ctx.data.researchOrganization.id)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_61, _hoisted_63))
                  : _createCommentVNode("", true),
                (_ctx.data.researchOrganization)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      _createElementVNode("p", null, [
                        _createVNode(_component_IconTextBlock, {
                          icon: "icon-pin",
                          label: "Organization Street 1 2000 City Building Room, Nr",
                          href: _ctx.data.researchOrganization.id
                        }, null, 8, ["href"])
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(_component_IconTextBlock, {
                          icon: "pi pi-link",
                          label: "https://www.um.si",
                          href: _ctx.data.researchOrganization.id
                        }, null, 8, ["href"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_65
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.displayContains('infoList') && _ctx.data.infoList)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 7 }, _renderList(_ctx.data.infoList, (list, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                _createElementVNode("div", _hoisted_66, [
                  (list.title)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_67, [
                        _createElementVNode("strong", {
                          class: "text-color-um-blue",
                          innerHTML: list.title
                        }, null, 8, _hoisted_68)
                      ]))
                    : _createCommentVNode("", true),
                  (list.children)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.children, (child, index_child) => {
                          return (_openBlock(), _createElementBlock("p", { key: index_child }, [
                            _createVNode(_component_IconTextBlock, {
                              icon: child.icon,
                              label: child.label,
                              to: child.to,
                              href: child.href
                            }, null, 8, ["icon", "label", "to", "href"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_70
              ], 64))
            }), 128))
          : _createCommentVNode("", true),
        (_ctx.displayContains('linkList') && _ctx.data.linkList)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 8 }, _renderList(_ctx.data.linkList, (list, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                _createElementVNode("div", _hoisted_71, [
                  (list.title)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_72, [
                        _createElementVNode("strong", {
                          class: "text-color-um-blue",
                          innerHTML: list.title
                        }, null, 8, _hoisted_73)
                      ]))
                    : _createCommentVNode("", true),
                  (list.children)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.children, (child, index_child) => {
                          return (_openBlock(), _createElementBlock("p", { key: index_child }, [
                            (child.href)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: _ctx.href,
                                  class: "link",
                                  target: "_blank",
                                  innerHTML: child.title
                                }, null, 8, _hoisted_75))
                              : (child.to)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 1,
                                    class: "link",
                                    to: child.to
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", {
                                        innerHTML: child.title
                                      }, null, 8, _hoisted_76)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.data.accordion.length)
                  ? (_openBlock(), _createElementBlock("hr", _hoisted_77))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          : _createCommentVNode("", true),
        (_ctx.displayContains('accordion') && _ctx.data.accordion)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 9 }, _renderList(_ctx.data.accordion, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "product__accordion"
              }, [
                (item.children)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                      _createVNode(_component_Accordion, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, index_child) => {
                            return (_openBlock(), _createBlock(_component_AccordionTab, {
                              key: index_child,
                              header: child.title
                            }, {
                              default: _withCtx(() => [
                                (child.content)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      innerHTML: child.content
                                    }, null, 8, _hoisted_79))
                                  : (child.infoList)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(child.infoList, (list, index) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                          (list.title)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_80, [
                                                _createElementVNode("strong", {
                                                  innerHTML: list.title
                                                }, null, 8, _hoisted_81)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (list.children)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.children, (child, index_child) => {
                                                  return (_openBlock(), _createElementBlock("p", { key: index_child }, [
                                                    _createVNode(_component_IconTextBlock, {
                                                      icon: child.icon,
                                                      label: child.label,
                                                      to: child.to,
                                                      href: child.href
                                                    }, null, 8, ["icon", "label", "to", "href"])
                                                  ]))
                                                }), 128))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128))
                                    : (child.location)
                                      ? (_openBlock(), _createBlock(_component_GoogleMapsSmall, {
                                          key: 2,
                                          location: _ctx.data.location
                                        }, null, 8, ["location"]))
                                      : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["header"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          : _createCommentVNode("", true),
        (_ctx.displayContains('location') && _ctx.data.location)
          ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
              _hoisted_84,
              _createVNode(_component_GoogleMapsSmall, {
                location: _ctx.data.location
              }, null, 8, ["location"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.$slots.actions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
            _hoisted_86,
            _renderSlot(_ctx.$slots, "actions")
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}